import { render, staticRenderFns } from "./Vuemenuitem.vue?vue&type=template&id=f5166154&"
import script from "./Vuemenuitem.vue?vue&type=script&lang=js&"
export * from "./Vuemenuitem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports